import(/* webpackMode: "eager" */ "/app/apps/web/src/app/(marketing)/gadgets/page.tsx");
